// extracted by mini-css-extract-plugin
export default {"container":"escalation-reason-input_container__mUGgE","header":"escalation-reason-input_header__3OYf7"};